/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Fragment, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCcVisa, faCcMastercard, faCcAmex, } from '@fortawesome/free-brands-svg-icons';
import { faCreditCard } from '@fortawesome/pro-light-svg-icons';
import { Card } from './Card';
import { Skeleton } from './Skeleton';
import { FatRow } from './FatRow';
export var JudoCardField = function (_a) {
    var className = _a.className, value = _a.value, judo = _a.judo;
    useEffect(function () {
        if (!judo || value)
            return;
        judo.createCardDetails('judopay-payment-iframe', {
            iframe: {
                layout: 'compact',
            },
        });
    }, [judo, value]);
    return !judo ? (jsx(Card, { as: Skeleton, sx: { height: 100, width: 320 } })) : value ? (jsx(Card, { className: className, sx: { px: 2, py: 3 } },
        jsx(FatRow, { title: jsx(Fragment, null,
                jsx(FontAwesomeIcon, { icon: value.brand === 'visa'
                        ? faCcVisa
                        : value.brand === 'mastercard'
                            ? faCcMastercard
                            : value.brand === 'amex'
                                ? faCcAmex
                                : faCreditCard, sx: { mr: 2 } }),
                "\u2022\u2022\u2022\u2022\u00A0 \u2022\u2022\u2022\u2022\u00A0 \u2022\u2022\u2022\u2022\u00A0",
                value.last4), meta: jsx(Fragment, null,
                "Expires ",
                value.expiresMonth,
                "/",
                value.expiresYear) }))) : (jsx("div", { className: className, id: "judopay-payment-iframe", sx: { width: '320px' } }));
};
//# sourceMappingURL=JudoCardField.js.map